module.exports = __webpack_public_path__ + "static/community-ambassadors-photo@2x-9c2e6eb7bfadd6770b2b698200f2d478.jpg";